var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-snackbar',{attrs:{"value":_vm.$warningMessage,"color":"orange","top":"","centered":"","timeout":"5000"}},[_c('v-icon',{attrs:{"left":"","color":"white"}},[_vm._v("mdi-alert")]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$warningMessage)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }